import Button from "@material-ui/core/Button";
import { styled } from "@material-ui/core/styles";

export const StyledButton = styled(Button)({
  height: "26px",
  padding: "0px 10px 0px 10px",
  boxShadow: "0px 5px 5px rgba(0, 0, 0, 0.75)",
  background: "#1464f6",
  color: "#ffffff",
  borderColor: "#1464f6",
  borderWidth: "1px",
  borderStyle: "solid",
  borderRadius: "10px 10px 10px 10px",
  fontFamily: "Raleway",
  fontWeight: "bold",
  fontSize: "12px",
  textAlign: "center",
  minWidth: "128px",
  "&:hover": {
    border: "none",
    color: "#000",
  },
  textTransform: "none",
});
